// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgFamilyRoom = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={color}
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.384 3H8.262a.743.743 0 0 0-.743.743v2.705H3.486V3.743A.753.753 0 0 0 2.743 3 .743.743 0 0 0 2 3.743v5.212a.743.743 0 0 0 .743.743.753.753 0 0 0 .743-.743v-.991h13.028v.99a.753.753 0 0 0 .743.744.743.743 0 0 0 .743-.743v-3.33A2.626 2.626 0 0 0 15.384 3Zm-6.38 3.448V4.466h6.38a1.13 1.13 0 0 1 1.13 1.14v.822H8.955l.05.02Z"
    />
    <path d="M5.478 5.596a.99.99 0 1 0 0-1.982.99.99 0 0 0 0 1.982Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.384 10.312H8.262a.731.731 0 0 0-.743.743v2.705H3.486v-2.705a.744.744 0 0 0-1.029-.69.731.731 0 0 0-.457.69v5.202a.733.733 0 0 0 .743.743.743.743 0 0 0 .743-.743v-.99h13.028v.99a.743.743 0 0 0 .743.743.731.731 0 0 0 .743-.743v-3.33a2.616 2.616 0 0 0-2.616-2.615Zm-6.38 3.448v-1.982h6.38a1.129 1.129 0 0 1 1.13 1.13v.832H8.955l.05.02Z"
    />
    <path d="M5.478 12.898a.99.99 0 1 0 0-1.982.99.99 0 0 0 0 1.982Z" />
  </svg>
)

export default SvgFamilyRoom
